<template>
	<div class="clear">
		<div class="section-block" v-if="qxParamsMap.qxjike_user_id">
			<div class="section-head">用户信息</div>
			<div class="row" v-for="(item, key) in userInfoObj">
				<label class="label">{{key}}：</label>
				<div class="cont">{{ item }}</div>
			</div>
			<div class="row">
				<label class="label">咨询渠道：</label>
				<div class="cont">{{qxParamsMap.qxjike_channel}}</div>
			</div>
		</div>
		<div class="section-block" v-if="qxParamsMap.qxjike_user_id" v-loading="orderLoading">
			<el-tabs v-model="orderListType" @tab-click="getOrderList">
				<el-tab-pane label="未完结订单" name="first" />
				<el-tab-pane label="售后中订单" name="second" />
				<!-- <el-tab-pane label="全部订单" name="third" /> -->
			</el-tabs>
			<template v-if="orderList.length">
				<template v-for="(orderItem, i) in orderList">
					<div class="hr" v-if="i"></div>
					<template v-for="(item, key) in orderItem">
						<div class="row" v-if="key != '旗帜等级'">
							<label class="label">{{key}}：</label>
							<div class="cont">
								<svg-icon v-if="key === '备注信息' && orderItem['旗帜等级']" :class="['flag-icon', 'style' + orderItem['旗帜等级']]" icon-class="flag" />
								{{ item }}
								<el-button type="primary" class="min-btn" size="mini" v-if="key === '备注信息'" @click="showRemarkFun(orderItem)">编辑</el-button>
								<el-button type="primary" plain class="min-btn copy-btn" size="mini" @click="copyText(item)">复制</el-button>
							</div>
						</div>
					</template>
				</template>
			</template>
			<div v-else style="text-align: center; padding-bottom: 10px">暂无数据</div>
		</div>
		<div class="section-block">
			<div class="section-head">咨询记录</div>
			<template v-if="consultationRecord.length">
				<div class="row" v-for="(item, i) in consultationRecord">{{i + 1}}、{{item.start_time}}</div>
			</template>
			<div v-else style="text-align: center; padding-bottom: 10px">暂无数据</div>
		</div>

		<el-dialog title="修改备注" width="400px" :visible.sync="editRemarkObj.show" :close-on-click-modal="false">
			<el-form size="mini" label-position="top" style="margin: -25px 0">
				<el-form-item label="订单标注">
					<el-radio-group v-model="editRemarkObj.flag">
						<el-radio :label="1"><svg-icon class="flag-icon style1" icon-class="flag" /></el-radio>
						<el-radio :label="2"><svg-icon class="flag-icon style2" icon-class="flag" /></el-radio>
						<el-radio :label="3"><svg-icon class="flag-icon style3" icon-class="flag" /></el-radio>
						<el-radio :label="4"><svg-icon class="flag-icon style4" icon-class="flag" /></el-radio>
						<el-radio :label="5"><svg-icon class="flag-icon style5" icon-class="flag" /></el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item :error="editRemarkObj.error" label="备注信息">
					<el-input type="textarea" :rows="5" placeholder="请输入备注" v-model="editRemarkObj.remark"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="editRemarkObj.show = false" size="small">取 消</el-button>
				<el-button type="primary" @click="submitEditRemark" size="small">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	data () {
		return {
			qxParamsMap: {},
			userInfoObj: {},
			orderList: [],
			consultationRecord: [],
			orderListType: 'first',
			orderLoading: false,
			editRemarkObj: {
				show: false
			}
		}
	},
	computed: {
		userInfo () {
			return this.$store.state.userInfo;
		},
		currentConversation () {
			return this.$store.state.currentConversation;
		}
	},
	props: {
		extInfos: {
			type: Array,
			default: () => []
		}
	},
	created() {
		this.init();
	},
	methods: {
		// 初始化
		init () {
			this.qxParamsMap = {}
			for (let i = 0; i < this.extInfos.length; i++) {
				let item = this.extInfos[i];
				if (item.name == 'qxjike_product_no' || item.name == 'qxjike_user_id' || item.name == 'qxjike_channel') {
					this.qxParamsMap[item.name] = item.value;
				}
			}

			this.getUserInfo();
			this.getOrderList()
			this.getConsultationRecord()
			this.saveUserInfo()
		},

		// 保存用户信息
		saveUserInfo () {
			if (!this.qxParamsMap.qxjike_user_id) {
				return
			}

			this.$axios.post(API_ROOT.url + '/SessionApi.saveSessionUserInfo', {
				userId: this.qxParamsMap.qxjike_user_id,
				sessionId: this.currentConversation.id,
				channel: this.qxParamsMap.qxjike_channel
			})
		},

		// 获取用户信息
		getUserInfo () {
			if (!this.qxParamsMap.qxjike_user_id) {
				return
			}

			let data = {
				userId: this.qxParamsMap.qxjike_user_id,
				shopId: this.$store.state.currentShop ? this.$store.state.currentShop.id : null
			}
			let sessionId = this.currentConversation.id;

			this.userInfoObj = {};
			this.$axios.post(API_ROOT.url + '/QxJiKeApi.queryUserInfo', data).then(result => {
				if(sessionId != this.currentConversation.id) return;
				if (result.status) {
					this.userInfoObj = result.data
				} else {
					this.$message.error('获取用户信息失败，失败原因：' + result.msg);
				}
			}, response => {
				if(sessionId != this.currentConversation.id) return;
				this.$message.error('获取用户信息失败，错误码(' + response + ')');
			})
		},

		// 获取订单列表
		getOrderList (type) {
			if (this.orderListType === 'first') {
				this.getOrderListApi(API_ROOT.url + '/QxJiKeApi.queryNotCompleteOrderInfo')
			} else if (this.orderListType === 'second') {
				this.getOrderListApi(API_ROOT.url + '/QxJiKeApi.queryAfterSaleOrderInfo')
			} else if (this.orderListType === 'third') {
				this.getOrderListApi(API_ROOT.url + '/QxJiKeApi.queryAllOrders')
			}
		},

		getOrderListApi (url) {
			if (!this.qxParamsMap.qxjike_user_id) {
				return
			}

			let data = {
				userId: this.qxParamsMap.qxjike_user_id,
				shopId: this.$store.state.currentShop ? this.$store.state.currentShop.id : null
			}
			let sessionId = this.currentConversation.id;

			this.orderLoading = true
			this.$axios.post(url, data).then(result => {
				if(sessionId != this.currentConversation.id) return;
				this.orderLoading = false
				if (result.status) {
					this.orderList = result.data || []
				} else {
					this.orderList = []
					this.$message.error('获取订单信息失败，失败原因：' + result.msg);
				}
			}, response => {
				if(sessionId != this.currentConversation.id) return;
				this.$message.error('获取订单信息失败，错误码(' + response + ')');
				this.orderList = []
				this.orderLoading = false
			})
		},

		// 获取咨询记录
		getConsultationRecord () {
			let data = {
				clientId: this.currentConversation.clientid
			}

			this.$axios.post(API_ROOT.url + '/tjkOperation/SessionApi.getRecentSessions', data).then(result => {
				if (result.status) {
					this.consultationRecord = result.data;
				} else {
					this.$message.error('查询咨询记录失败，失败原因：' + result.msg);
				}
			}, response => {
				this.$message.error('查询咨询记录失败，错误码(' + response + ')');
			})
		},

		// 显示备注弹窗
		showRemarkFun (item) {
			this.editRemarkObj = {
				show: true,
				flag: item['旗帜等级'] || null,
				remark: item['备注信息'] || null,
				row: item
			}
		},

		// 提交备注修改
		submitEditRemark () {
			if (!this.editRemarkObj.remark) {
				this.$set(this.editRemarkObj, 'error', '备注不能为空');
				return;
			}

			let data = {
				req: {
					// merProductNo: this.qxParamsMap.qxjike_product_no,
					merOrderNo: this.editRemarkObj.row['用户单号'],
					content: this.editRemarkObj.remark,
					bannerLevel: this.editRemarkObj.flag,
					createName: this.userInfo.real_name
				}
			}

			this.$axios.post(API_ROOT.url + '/QxJiKeApi.addOrderRemark', data).then(result => {
				this.getOrderList()
				this.$set(this.editRemarkObj, 'show', false);
			}, response => {
				this.$message.error('修改备注失败，错误码(' + response + ')');
			})
		},

		// 复制
		copyText(text) {
			const input = document.createElement('textarea')
			input.value = text
			document.body.appendChild(input)
			input.select()
			if (document.execCommand('copy')) {
				document.execCommand('copy')
				this.$message.success('复制成功')
			} else {
				this.$message.error('操作失败，请手动复制')
			}
			document.body.removeChild(input)
		},
	}
}
</script>

<style scoped lang="less">
	.section-block {
		margin: 10px;
		padding: 6px 10px;
		background: #f5f6f7;
		border-radius: 10px;
		font-size: 12px;
		color: rgb(102, 102, 102);
		line-height: 16px;
		.section-head {
			font-size: 14px;
			font-weight: 700;
			line-height: 22px;
		}
		.row {
			display: flex;
			padding: 3px 0;
			> .label {
				width: 75px;
				color: rgb(147, 147, 147);
			}
			> .cont {
				flex: 1;
			}
			&:hover {
				.copy-btn {
					display: inline-block;
				}
			}
		}
		.hr {
			margin: 15px;
			border-top: 1px solid #ddd;
		}
	}
	.min-btn {
		padding: 2px 7px;
	}
	.copy-btn {
		position: absolute;
		display: none;
		margin-left: 5px;
	}
	.flag-icon {
		font-size: 16px;
		&.style1 {
			color: #f71d1d;
		}
		&.style2 {
			color: #ff762b;
		}
		&.style3 {
			color: #44c854;
		}
		&.style4 {
			color: #486dff;
		}
		&.style5 {
			color: #be3af5;
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/aside/qxUser.vue